import { dateAva } from '../../api/bookingAPI';
import { getDetailsFun, orgPacksFun } from '../../api/infoAPI';
import { supBookingDetails } from '../../api/supportAdmin';
import errorHandle from '../../utils/errorHandle';

export const FetchPackList = async (type, setTrips, orgId, selectedStatus, limit, offset, setLoading) => {
    setLoading(true);
    try {
        const res = await orgPacksFun(type, orgId, limit, offset);
        setTrips(res.data);
    } catch (error) {
        errorHandle(error);
    } finally {
        setLoading(false);
    }
};

export const FetchBookingData = async (setBookingData, type, bookingId, setLoading) => {
    setLoading(true);
    try {
        const res = await supBookingDetails(type, bookingId);
        if (type === 'trip') {
            setBookingData(res.data);
        } else {
            setBookingData(res.data);
        }
    } catch (error) {
        errorHandle(error);
    } finally {
        setLoading(false);
    }
};

export async function fetchTripData(type, packId, setLoading, setPackData, setPackDates) {
    setLoading(true);
    try {
        // for getDateDetailsFun you get an array of objects with tripDate id, start and end date of each
        const allData = await getDetailsFun(type, packId);
        setPackData(allData.data.packdata);
        setLoading(false);
    } catch (error) {
        setLoading(false);
        errorHandle(error);
    }
}

export async function fetchTripDate(data, type) {
    try {
        const res = await dateAva(data, type);
        return res.data[0];
    } catch (error) {
        errorHandle(error);
        return null;
    }
}
